import { render, staticRenderFns } from "./RegionHeader.vue?vue&type=template&id=0aff95ce&scoped=true&"
import script from "./RegionHeader.vue?vue&type=script&lang=js&"
export * from "./RegionHeader.vue?vue&type=script&lang=js&"
import style0 from "./RegionHeader.vue?vue&type=style&index=0&id=0aff95ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff95ce",
  null
  
)

export default component.exports